import { ExperimentOfferFlow, PaymentData, PaymentInfo, SubscriptionStatus } from "../types";

export class SubscriptionData {
  statusData: SubscriptionStatus;
  paymentInfo: PaymentInfo;
  constructor(subscriptionStatus: SubscriptionStatus, paymentInfo: PaymentInfo) {
    this.statusData = subscriptionStatus;
    this.paymentInfo = paymentInfo;
  }

  isPaymentRequired(): boolean {
    // TODO: Revise hard coded nested prop 'basic'
    return (
      !this.statusData.subscription.basic.hasSubscription &&
      !this.statusData.subscription.basic.hasTrial
    );
  }

  missingPaymentInfo(): boolean {
    return Object.keys(this.paymentInfo).length === 0
  }

  getDaysAmount(): number {
    return this.paymentInfo.trial!.days
  }

  getPaymentData(): PaymentData {
    return this.isPaymentRequired()
      ? this.paymentInfo.payment!
      : this.paymentInfo.trial!.paymentAfterTrial;
  }

  getClientSecret(): string {
    return this.isPaymentRequired() ? this.getPaymentSecret() : this.getTrialSecret()
  }

  getPaymentSecret(): string {
      return this.paymentInfo!.payment!.stripePaymentIntent.clientSecret;
  }

  getTrialSecret(): string {
    return this.paymentInfo.trial!.stripeSetupIntent.clientSecret;
  }

  isMultiplan(): boolean {
    // TODO: Revise hard coded nested prop 'basic'
    return this.statusData.subscription.basic.experimentOfferFlow === ExperimentOfferFlow.multiplan
  }
}
